import styled from "styled-components";

export const ChatWrapper = styled.div`
  position: fixed;
  right: 20px;
  bottom: 50px;
  z-index: 9999;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  pointer-events: none;

  * {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  }
`;

export const Header = styled.div`
  padding: 12px 16px;
  background: #0198e9;
  color: white;
  font-weight: 600;
`;

export const MessagesArea = styled.div`
  flex: 1;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  background: #f3f4f6;
`;

export const MessageBlock = styled.div`
  align-self: ${(p) => (p.$from === "user" ? "flex-end" : "flex-start")};
  max-width: 85%;
`;

export const MetaLine = styled.div`
  font-size: 11px;
  opacity: 0.6;
  margin-bottom: 2px;
  text-align: ${(p) => (p.$from === "user" ? "right" : "left")};
`;

export const Bubble = styled.div`
  padding: 8px 10px;
  border-radius: 12px;
  background: ${(p) => (p.$from === "user" ? "#0198E9" : "white")};
  color: ${(p) => (p.$from === "user" ? "white" : "#111827")};
  font-size: 14px;
  line-height: 1.4;
  white-space: pre-wrap;
`;

export const BotText = styled.pre`
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const UserText = styled.pre`
  margin: 0;
  white-space: pre-wrap;
`;

export const ImageWrap = styled.div`
  margin-top: 8px;
`;

export const BotImage = styled.img`
  max-width: 100%;
  border-radius: 12px;
  display: block;
`;

export const TypingIndicator = styled.div`
  font-size: 12px;
  opacity: 0.6;
`;

export const InputForm = styled.form`
  padding: 10px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 8px;
  background: white;
`;

export const TextInput = styled.input`
  flex: 1;
  padding: 8px 10px;
  border-radius: 999px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  outline: none;
`;
export const ChatWindow = styled.div`
  width: 360px;
  height: 520px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-bottom: 12px;
  pointer-events: all; /* so you can click/type inside */
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.0); /* fully transparent */
  z-index: 9998;
`;

export const FloatingButton = styled.button`
  width: 56px;
  height: 56px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(0,0,0,0.25);
  font-size: 22px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
`;

export const SendButton = styled.button`
  border-radius: 999px;
  padding: 8px 14px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  background: #0198e9;
  color: white;
`;